module.exports = __webpack_public_path__ + "assets/img/block-8d277ac3.png";